<template>
  <div id="app">
    <div>
<!--      <img src="./assets/logo.png" style="position: absolute">-->
    </div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /*margin-top: 60px;*/
  margin: -8px;
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue